var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { shade } from 'polished';
import React from 'react';
import styled from 'styled-components';
import analytics, { EVENTS as E } from 'shared-assets/lib/analytics';
import colors from 'shared-assets/lib/colors';
import rollbar from 'shared-assets/src/errors/errors';
export var styledFunc = function () { return ({}); };
export var Styled = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  text-decoration: none;\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  cursor: pointer;\n  text-decoration: none;\n  &:hover {\n    color: ", ";\n  }\n"])), colors.primary, shade(0.2, colors.primary));
export var EVENTS = {
    LINK_CLICKED: E.LINK_CLICKED,
    BUTTON_CLCIKED: E.BUTTON_CLICKED,
};
var A = function (_a) {
    var children = _a.children, onClick = _a.onClick, track = _a.track, props = __rest(_a, ["children", "onClick", "track"]);
    var onClickWithTracking = function (e) {
        var target = e.target;
        var href = !!target && target.href;
        if (!!track && typeof props.trackingProvider === 'function') {
            // if tracking a link tag then prevent default behavior
            e.preventDefault();
            var event_1 = track.event, data = track.data;
            event_1 = !event_1 ? EVENTS.LINK_CLICKED : event_1;
            var redirect_1 = function () {
                if (typeof href === 'string' && !!href) {
                    if (props.target === '_blank') {
                        props.windowProvider.open(href);
                    }
                    else {
                        props.windowProvider.location.assign(href);
                    }
                }
            };
            var redirectTimeout_1 = setTimeout(redirect_1, 1000);
            props
                .trackingProvider(event_1, __assign({}, data))
                .then(function () {
                clearTimeout(redirectTimeout_1);
            })
                .catch(function (error) {
                rollbar.error(error);
                clearTimeout(redirectTimeout_1);
            })
                .finally(function () {
                // always redirect even if there is an error
                redirect_1();
            });
        }
        if (!!onClick) {
            onClick(e);
        }
    };
    var onClickCallback = !!track
        ? onClickWithTracking
        : !!onClick
            ? onClick
            : function () { return null; };
    return (React.createElement(Styled, __assign({ onClick: onClickCallback }, props), children));
};
A.defaultProps = {
    trackingProvider: analytics.track,
    windowProvider: window,
};
export default A;
var templateObject_1;
